import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} मुखपृष्ठ`,
    languageButtonLabel: `भाषा`,
    languageModalTitle: `भाषा चुनें`,
    languageModalCloseLabel: `भाषा मेनू बंद करें`,
  },
  languageOptions: {
    'en-US': {
      label: `अंग्रेज़ी`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `अंग्रेज़ी (केन्या)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `अंग्रेज़ी (नाइजीरिया)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `अंग्रेज़ी (सिंगापुर)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `पुर्तगाली`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `जर्मन`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `स्पैनिश`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `फ़्रेंच`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `इटालियन`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `डच`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `नॉर्डिक और बाल्टिक`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `जापानी`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `कोरियाई`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `मैंडरिन`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `कैंटोनीज़`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `थाई`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `हिन्दी`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `फ़ारसी`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `रूसी`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `अरबी`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `मोरक्कन अरबी`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `भाषा चुनें`,
    closeLabel: `भाषा मेनू बंद करें`,
  },
  languageHint: (ctx) => `${ctx.localesCount}+ भाषाओं के बीच तुरंत स्विच करें।`,
  readPagePrompt: ({languageLabel}) => `इस पेज को ${languageLabel} में पढ़ें।`,
};
